module.exports = __webpack_public_path__ + "req_Med.png";